const ENDPOINT = 'GETdashboardprofile';
function getDashboardProfile(gateway, params = {}) {
    return gateway.get(getDashboardProfile.endpoint, params);
}
getDashboardProfile.endpoint = ENDPOINT;

export { getDashboardProfile as default };
//# sourceMappingURL=getDashboardProfile.js.map
